import React, { Fragment } from 'react';
import './App.css';
import { BrowserRouter, Route, Router, Switch } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import { BASEURL } from './constant/constant';
import LoginRouter from './routers/LoginRouter';
import { ThemeProvider, createTheme } from '@mui/material';
import HomeRouter from './routers/HomeRouter';


const theme = createTheme({
  typography: {
    // fontFamily: '"Sarabun", sans-serif !important',
    fontFamily: '"Prompt", sans-serif!important'
  },
});

function App() {
  // const theme = unstable_createMuiStrictModeTheme();
  return (
    <ThemeProvider theme={theme}>
      <CookiesProvider>
        {/* {test()} */}
        <BrowserRouter basename={BASEURL}>
          {/* <Suspense fallback={<SuspenseContent />}> */}
          <React.Fragment>
            <Route>
              {/* <Fragment> */}
              {HomeRouter}
              {LoginRouter}
              {/* <Route path='*' component={PageNotFound} /> */}
              {/* </Fragment> */}
            </Route>
          </React.Fragment>


          {/* </Suspense> */}
        </BrowserRouter>
      </CookiesProvider>
    </ThemeProvider>
    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Edit <code>src/App.tsx</code> and save to reload.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>
  );
}

export default App;
